module.exports = __webpack_public_path__ + "media/images/icons/digits-icon-3bd25a9d1ab84cd55f8ddf621ed73930.svg";